import Swiper, {Autoplay, Navigation, Pagination} from 'swiper';
import {Utils} from '../../common/scripts/utils';

const promotionsSliders = [...document.querySelectorAll('.j-slider-promotions')];
const firstScreenSliders = [...document.querySelectorAll('.j-first-screen-slider')];
// Счетчик проверок запуска Апи ютьюба
let counter = 0;
// Объект со всеми инициализированными плеерами
const playersData = {};

/**
 * Ставим на паузу все видео
 */
const pauseAllVideo = () => {
    for (const player in playersData) {
        if ({}.hasOwnProperty.call(playersData, player)) {
            playersData[player].pauseVideo();
        }
    }
};

/**
 * Запускает видео в слайдере
 * @param {object} swiper - объект слайдера
 */
const startVideo = (swiper) => {
    const iframe = [...swiper.slides[swiper.activeIndex].querySelectorAll('iframe')];

    if (!iframe.length) {
        pauseAllVideo();

        return;
    }

    // Вычисляем устройство
    const resolution = Utils.isMobile() ? 'mobile' : 'desktop';

    // Находим нужный элемент с видео
    const sourceFrame = iframe.find((item) => {
        return item.dataset.resolution === resolution;
    });

    const nowPlayer = playersData[sourceFrame.id];

    nowPlayer?.seekTo(0);
    nowPlayer?.playVideo();
};

const onPlayerReady = (event) => {
    const videoID = event.target.h.id;

    playersData[videoID] = event.target;

    event.target.mute();
    event.target.playVideo();
};

const pauseVideo = (event) => {
    const videoID = event.target.h.id;

    playersData[videoID] = event.target;

    event.target.pauseVideo();
};

/**
 * Инициализируем видео ютьюба
 * @param {array} videoList - массив с объектами данных для плееров ютьюба
 */
const setVideo = (videoList) => {
    const inputPlayer = (id, play) => {
        // eslint-disable-next-line
        new YT.Player(id, {
            events: {
                onReady: play ? onPlayerReady : pauseVideo
            }
        });
    };

    // eslint-disable-next-line func-names
    window.onYouTubeIframeAPIReady = () => {
        videoList.forEach((video) => {
            inputPlayer(video.id, video.play);
        });
    };

    const tag = document.createElement('script');
    const firstScriptTag = document.getElementsByTagName('script')[0];

    if (!window.YT && counter < 1) {
        tag.src = 'https://www.youtube.com/player_api';
        firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

        counter = 2;
    }
};

promotionsSliders.forEach((promotionsSlider) => {
    return new Swiper(promotionsSlider, {
        modules         : [Navigation, Autoplay],
        wrapperClass    : 'j-slider-promotions__wrapper',
        slideClass      : 'j-slider-promotions__slide',
        slideActiveClass: 'is-active',
        slideNextClass  : 'is-next',
        slidesPerView   : 'auto',
        breakpoints     : {
            1280: {
                slidesPerView: 1
            }
        },
        autoplay: {
            pauseOnMouseEnter: true
        },
        navigation: {
            prevEl       : '.j-slider-promotions__arr-prev',
            nextEl       : '.j-slider-promotions__arr-next',
            disabledClass: 'is-disabled'
        },
        on: {
            slideChangeTransitionEnd(swiper) {
                if (swiper.isEnd) {
                    swiper.params.autoplay.reverseDirection = true;
                } else if (swiper.isBeginning) {
                    swiper.params.autoplay.reverseDirection = false;
                }
            },
            resize(swiper) {
                firstScreenSliders.forEach((firstScreenSlider) => {
                    firstScreenSlider.style.setProperty('--promotions-height', `${swiper.height}px`);
                });
            }
        }
    });
});

/* eslint-disable max-lines-per-function */
firstScreenSliders.forEach((firstScreenSlider) => {
    const titleNode = firstScreenSlider.querySelector('.j-first-screen__slider-title');
    const defaultTitle = titleNode?.innerHTML || '';

    return new Swiper(firstScreenSlider, {
        modules         : [Autoplay, Navigation, Pagination],
        wrapperClass    : 'j-first-screen-slider__wrapper',
        slideClass      : 'j-first-screen-slider__slide',
        slideActiveClass: 'is-active',
        slideNextClass  : 'is-next',
        slidesPerView   : 1,
        loop            : true,
        // autoplay        : {
        //    delay               : 3000,
        //    disableOnInteraction: false
        // },
        navigation      : {
            prevEl: '.j-first-screen-slider__arr-prev',
            nextEl: '.j-first-screen-slider__arr-next'
        },
        pagination: {
            el               : '.j-first-screen-slider__pagination',
            bulletClass      : 'first-screen__slider-bullet',
            bulletActiveClass: 'is-active',
            clickable        : true
        },
        on: {
            init(swiper) {
                const videoSlides = swiper.slides.filter((slide) => {
                    return slide.classList.contains('is-video');
                });
                const videoList = [];

                videoSlides.forEach((slide, index) => {
                    const videoWrapperList = [...slide.querySelectorAll('.j-first-screen__video-wrapper')];


                    videoWrapperList.forEach((videoWrapper) => {
                        // 128 - абстрактное число
                        videoWrapper.id = videoWrapper.id ?
                            videoWrapper.id :
                            `player-${Math.floor(Math.random() * 128)}`;

                        const videoID = videoWrapper?.id;

                        const resolution = Utils.isMobile() ? 'mobile' : 'desktop';

                        const play = slide.classList.contains('is-video') && index === 0 &&
                            resolution === videoWrapper.dataset.resolution;

                        if (videoID) {
                            videoList.push({id: videoID,
                                play});
                        }
                    });
                });

                if (videoList.length) {
                    setVideo(videoList);
                }
            },
            slideChangeTransitionStart(swiper) {
                const currentSlide = swiper.slides[swiper.activeIndex];
                const imageAlt = currentSlide.querySelector('img')?.alt;

                if (imageAlt || defaultTitle) {
                    titleNode.innerHTML = imageAlt || defaultTitle;
                }

                startVideo(swiper);
            },
            slideChangeTransitionEnd() {
                // startVideo(swiper);
            }
        }
    });
});
/* eslint-enable max-lines-per-function */
